import { object } from "yup";
import { defaultValidation } from ".";

export const deploySchema = object().shape({
  repo_name: defaultValidation("Repo name"),
});
